// extracted by mini-css-extract-plugin
export default {"ag-styles":"M_g","alert":"M_dC","info":"M_dD","flag":"M_dF"};